const messageKeys = [
  'CLAIM_SUCCESS',
  'CLAIM_ERROR',
] as const;

const messages: Record<ReferralsStoreMessage, ReferralsStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<ReferralsStoreMessage, ReferralsStoreMessage>;
export default messages;

export type ReferralsStoreMessage = (typeof messageKeys)[number];
